var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_ol_advisory_style_interface = function () {
    OCS.Viewer.Interfaces.OlAdvisoryStyle = {
        options: {
            layer_style_ops: {},
            advisory_style_type_text: 'advisory',
            advisory_style_ops: {
                filled: false,
                fill_opacity: 0,
                highlight_opacity: 0.4,
                highlight_width_mult: 1,
                line_width: 1,
                width: 1.0
            },
        },
        get_advisory_layer_style_method: function (feature, res) {
            return feature.style_method(feature, res, this.options);
        }

    }; // End OCS.Viewer.Interfaces.OlAdvisoryStyle
};
OCS.Viewer.Functions.define_ol_advisory_style_interface();